import { useUserStore } from '@/stores/userStore.js'
import { useAuthStore } from '@/stores/authStore.js'
import { toRaw, watch } from 'vue'

export const useServiceWorkerState = () => {
  const userStore = useUserStore()
  const authStore = useAuthStore()

  function refreshServiceWorkerState() {
    navigator.serviceWorker.ready.then((registration) => {
      if (registration.active) {
        registration.active.postMessage({
          type: "stateUpdate",
          user: toRaw(userStore.user),
          authenticationKey: toRaw(userStore.authenticationKey),
          deviceIdentifier: toRaw(authStore.deviceIdentifier),
          // The worker replays a queued request only while the partner it was made for is selected
          partnerId: userStore.partner?.id ?? null
        })
      }
    })
  }

  function watchState()  {
    watch(() => [userStore.user, authStore.deviceIdentifier, userStore.authenticationKey, userStore.partner?.id],
      refreshServiceWorkerState, { deep: true })
  }

  return {
    refreshServiceWorkerState, watchState
  }
}